import React, { useEffect, useState } from "react";
import styles from './ProgramCoordinatorPermissions.module.scss';
import pageStyles from '../createInstructor/CreateInstructor.module.scss';
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import Toggle from "../../../components/toggle/Toggle";
import Button from "../../../components/button/Button";
import LoadingOverlay from "../../../components/loadingOverlay/LoadingOverlay";
import axiosClient from "../../../api/axiosClient";
import { useNavigate, useParams } from "react-router-dom";
import { useToasts } from "../../../contexts/ToastContext";

const ProgramCoordinatorPermissions = () => {
  const { coordinatorId } = useParams();
  const { showToast } = useToasts();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [coordinator, setCoordinator] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    axiosClient.get(`users/program-coordinator/${coordinatorId}/permissions`)
      .then((response) => {
        if (response.data?.permissions) {
          setPermissions(response.data.permissions);
        }
        if (response.data?.coordinator) {
          setCoordinator(response.data.coordinator);
        }
      })
      .catch((error) => showToast(error.message, 'error'))
      .finally(() => setIsLoading(false));
  }, [coordinatorId, showToast]);

  const handleToggle = (key) => {
    setPermissions((prev) =>
      prev.map((p) => p.key === key ? { ...p, enabled: !p.enabled } : p)
    );
  };

  const handleSave = async () => {
    const payload = permissions.reduce((acc, p) => {
      acc[p.key] = p.enabled;
      return acc;
    }, {});

    setIsSaving(true);
    await axiosClient.patch(`users/program-coordinator/${coordinatorId}/permissions`, payload)
      .then((response) => {
        showToast(response.message);
        navigate('/program-coordinators');
      })
      .catch((error) => showToast(error.message, 'error'))
      .finally(() => setIsSaving(false));
  };

  return (
    <>
      {(isLoading || isSaving) && <LoadingOverlay />}
      <div className={pageStyles.breadcrumbs}>
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Program Coordinator Management', path: '/program-coordinators' },
            { label: coordinator ? `${coordinator.firstName} ${coordinator.lastName}` : '...', path: `/program-coordinators/edit/${coordinatorId}` },
            { label: 'Permissions' }
          ]}
        />
      </div>
      <div className={pageStyles.container}>
        <div className={styles.card}>
          <h2 className={styles.title}>Permissions</h2>
          <div className={styles.list}>
            {permissions.map((permission) => (
              <div key={permission.key} className={styles.item}>
                <span className={styles.label}>{permission.label}</span>
                <Toggle
                  checked={permission.enabled}
                  onChange={() => handleToggle(permission.key)}
                  labelPosition="right"
                />
              </div>
            ))}
          </div>
          <div className={styles.actions}>
            <Button
              label="Cancel"
              variant="white"
              size="medium"
              onClick={() => navigate('/program-coordinators')}
            />
            <Button
              label="Update Permissions"
              variant="primary"
              size="medium"
              onClick={handleSave}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgramCoordinatorPermissions;
